import React, { useEffect, useMemo, useState } from 'react'
import { Ordermodal } from "../elements/ordermodal";
import Orderslist from "./orderslist";
import { Carcontext } from "../context/carcontext";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../elements/alert";
import { fetchOrders } from "../redux/actions";

const OrdersPage = () => {

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [modal, setModal] = useState({})
    const [passingData, setPassingData] = useState(null)
    const alertBox = useSelector(state => state.app.alertBox)
    const theme = useSelector(state => state.app.theme)
    const paginationData = useSelector(state => state.orders.paginationData)

    const [currentStatus, setCurrentStatus] = useState('in progress')

    const orderModal = useMemo(() => {
        return <Ordermodal order={passingData} theme={theme} />
    }, [passingData, theme])

    useEffect(() => {
        const modalBox = document.querySelector('.modal-wrapper')
        setModal(modalBox)
    }, [])

    const openOrderModal = (order) => {
        modal.style.cssText = "opacity: 1; visibility: visible;";
        setPassingData(order)
    }

    const CloseModal = () => {
        modal.style.cssText = "opacity: 0; visibility: hidden;";
    }

    const changeOrdersStatus = (status) => {
        if (currentStatus === status) {
            return null
        } else {
            setCurrentStatus(status)
        }
    }

    const nextPage = (nextPage) => {
        dispatch(fetchOrders(nextPage))
    }

    return (
        <Carcontext.Provider value={{
            openOrderModal, CloseModal, theme
        }}>
            <div className="content forOrder">
                {alertBox && <Alert text={alertBox.text} type={alertBox.type} />}
                <div className="wrapper forOrder">
                    <div className="modal-wrapper">{orderModal}</div>
                    <div className="horizontal-scroll">
                        <div className={`orders-tabs ${theme}`}>
                            <div className={`order-tab ${(() => {
                                if (currentStatus === 'in progress') {
                                    return 'visible'
                                }
                            })()}`} onClick={() => changeOrdersStatus('in progress')}><p>{t('inProgress')}</p></div>
                            <div className={`order-tab ${(() => {
                                if (currentStatus === 'finished') {
                                    return 'visible'
                                }
                            })()}`} onClick={() => changeOrdersStatus('finished')}><p>{t('finished')}</p></div>
                            <div className={`order-tab ${(() => {
                                if (currentStatus === 'reserved') {
                                    return 'visible'
                                }
                            })()}`} onClick={() => changeOrdersStatus('reserved')}><p>{t('pending')}</p></div>
                        </div>
                        <div className="order">
                            <div className={`order-info ${theme}`}>
                                <span className="subtitle">Id</span>
                                <span className="subtitle">{t('fullName')}</span>
                                <span className="subtitle">{t('passport')}</span>
                                <span className="subtitle">{t('fromTo')}</span>
                                <span className="subtitle">{t('carInfo')}</span>
                                <span className="subtitle">{t('document')}</span>
                            </div>
                            {/*Передаем статус для списка ордеров*/}
                            <Orderslist status={`${currentStatus}`} />
                            <div className={`pagination-items ${theme}`}>
                                {
                                    !!paginationData.previous ? <div className="previos-page" onClick={() => nextPage(paginationData.previous)}>{t('previous')}</div> : ''
                                }
                                {
                                    !!paginationData.next ? <div className="next-page" onClick={() => nextPage(paginationData.next)}>{t('next')}</div> : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Carcontext.Provider>
    )
}

export default OrdersPage
